// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2TMOr","container":"styles_container__2Whhx","title":"styles_title__3hDom","wrapper":"styles_wrapper__36nrA","answer":"styles_answer__3ROBK"};